import {
  Sparkles, Compass, Eye, Layers, Hand, Heart, TrendingUp, Gem, Sun, ShieldHalf, Users,
} from "lucide-react";

export const BRAND = "Astrologer & Spiritual Healers";
export const PHONE_DISPLAY = "+1 368-886-0978";
export const PHONE_TEL = "tel:+13688860978";
export const WHATSAPP_URL = `https://wa.me/13688860978?text=${encodeURIComponent(
  "Hello, I would like to book a consultation."
)}`;
export const EMAIL = "astrologyhealer2284@gmail.com";
export const CITY = "Calgary, Alberta, Canada";
export const MAP_LINK = "https://maps.app.goo.gl/ZkLxAGEswVn2GW4U6";
export const MAP_EMBED = "https://www.google.com/maps?q=51.0736782,-113.9429045&z=15&output=embed";

export const HOURS = [{ day: "Monday – Sunday", time: "Open 24 hours" }];

export const TIME_SLOTS = [
  "Any time — flexible", "6:00 AM", "7:00 AM", "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
  "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM",
  "9:00 PM", "10:00 PM", "11:00 PM", "Late night (after 11 PM)",
];

export const SOCIALS = [
  { name: "Facebook", href: "https://www.facebook.com/share/1DNvJYnwNH/?mibextid=wwXIfr" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1548625289-5439d04309c4?auto=format&fit=crop&w=2000&q=80",
  cosmic: "https://images.unsplash.com/photo-1763793931071-f50aea235730?auto=format&fit=crop&w=1400&q=80",
  tarot: "https://images.unsplash.com/photo-1683217956204-d94282206523?auto=format&fit=crop&w=1200&q=80",
  crystal: "https://images.unsplash.com/photo-1621923647893-901f834b3e6a?auto=format&fit=crop&w=1200&q=80",
  meditation: "https://images.unsplash.com/photo-1538024333176-f25f63f873ee?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICES = [
  { id: "vedic-astrology", title: "Vedic Astrology", icon: Sparkles, image: "/service-images/vedic.webp",
    text: "A careful reading of your birth chart, planetary periods and karmic patterns to bring clarity to where you are and where you are heading." },
  { id: "horoscope-reading", title: "Horoscope Reading", icon: Compass, image: "/service-images/horoscope.webp",
    text: "Personal insight into current transits and upcoming cycles, so you can plan important moves with confidence and good timing." },
  { id: "psychic-reading", title: "Psychic Reading", icon: Eye, image: "/service-images/psychic.webp",
    text: "An intuitive session that looks beneath the surface of a situation, helping you understand feelings, blockages and possible outcomes." },
  { id: "tarot-card-reading", title: "Tarot Card Reading", icon: Layers, image: "/service-images/tarot.webp",
    text: "Thoughtful card spreads that reflect your questions back with honesty, offering practical perspective on choices and crossroads." },
  { id: "palm-reading", title: "Palm Reading", icon: Hand, image: "/service-images/palm.webp",
    text: "A traditional study of the lines and mounts of your hands, revealing tendencies in health, relationships, work and life path." },
  { id: "love-relationship-guidance", title: "Love & Relationship Guidance", icon: Heart, image: "/service-images/love.webp",
    text: "Compassionate guidance on compatibility, misunderstandings and emotional healing, for singles and couples alike." },
  { id: "career-business-guidance", title: "Career & Business Guidance", icon: TrendingUp, image: "/service-images/career.webp",
    text: "Astrological timing and clear advice for job changes, new ventures, partnerships and financial decisions." },
  { id: "marriage-guidance", title: "Marriage Guidance", icon: Gem, image: "/service-images/marriage.webp",
    text: "Kundali matching, insight into delays, and calm counsel to support harmony and understanding within a marriage." },
  { id: "spiritual-healing", title: "Spiritual Healing", icon: Sun, image: "/service-images/healing.webp",
    text: "Gentle energy work, meditation and chakra balancing to help you release heaviness and return to inner calm." },
  { id: "negative-energy-evil-eye-guidance", title: "Negative Energy / Evil Eye Guidance", icon: ShieldHalf, image: "/service-images/evil-eye.webp",
    text: "Traditional protective practices and guidance for those who feel weighed down by envy, negativity or a persistent run of bad luck." },
  { id: "family-personal-guidance", title: "Family & Personal Guidance", icon: Users, image: "/service-images/family.webp",
    text: "Supportive sessions for family tension, personal struggles and big life decisions, focused on peace and practical next steps." },
];

export const NOT_SURE = "Not sure yet - please advise";

// SAMPLE testimonials — replace with genuine client quotes
export const TESTIMONIALS = [
  { quote: "The reading gave me a calm, clear way to think about a career decision I had been stuck on for months.", name: "Sample Client", meta: "Career Guidance" },
  { quote: "Kind, patient and honest. I left the session feeling lighter and understood, not judged.", name: "Sample Client", meta: "Spiritual Healing" },
  { quote: "Our compatibility reading opened a conversation my partner and I really needed to have.", name: "Sample Client", meta: "Relationship Guidance" },
  { quote: "The tarot session was thoughtful and practical. I appreciated how everything was explained.", name: "Sample Client", meta: "Tarot Reading" },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/book", label: "Book" },
  { to: "/contact", label: "Contact" },
];
